import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5792d0e9")

_pushScopeId("data-v-5792d0e9")
const _hoisted_1 = {
  class: "grid",
  style: {"width":"900px"}
}
const _hoisted_2 = { class: "flex justify-end mt-10 gap-x-3" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_SendInvoiceReceiverRows = _resolveComponent("SendInvoiceReceiverRows")!
  const _component_button_fill = _resolveComponent("button-fill")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_InvoicePdfStruk = _resolveComponent("InvoicePdfStruk")!
  const _component_InvoicePdfA4 = _resolveComponent("InvoicePdfA4")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Dialog, {
      modelValue: _ctx.show,
      title: _ctx.modalTitle,
      class: "send-invoice",
      "onUpdate:modelValue": _ctx.onCloseModal
    }, {
      default: _withId(() => [
        _createVNode("div", _hoisted_1, [
          _createVNode(_component_SendInvoiceReceiverRows, {
            viaOptions: _ctx.viaOptions,
            formatOptions: _ctx.formatOptions,
            onUpdate: _ctx.onReceiversUpdate
          }, null, 8, ["viaOptions", "formatOptions", "onUpdate"])
        ]),
        _createVNode("div", _hoisted_2, [
          _createVNode(_component_button_fill, {
            onClick: _ctx.onSubmit,
            title: _ctx.$t('printReceipt.save'),
            class: "bg-red-lp-300 px-8 w-full",
            isDisabled: _ctx.isDisabledSubmit,
            isLoading: _ctx.isLoadingSend
          }, null, 8, ["onClick", "title", "isDisabled", "isLoading"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title", "onUpdate:modelValue"]),
    _createVNode(_component_InvoicePdfStruk, {
      ref: "struk",
      invoiceData: _ctx.invoiceDetail.header,
      items: _ctx.invoiceDetail.items
    }, null, 8, ["invoiceData", "items"]),
    _createVNode(_component_InvoicePdfA4, {
      ref: "invoice",
      invoiceData: _ctx.invoiceDetail.header,
      items: _ctx.invoiceDetail.items
    }, null, 8, ["invoiceData", "items"])
  ], 64))
})